import React from "react";
import PeopleManager from "@/components/app/PeopleManager";
export default function Teachers() { return <PeopleManager kind="teacher" />; }
